var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.383 7.183a.63.63 0 0 0 .625.625h2.5c.575 0 1.042-.466 1.042-1.041v-2.5a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v1.091a7.65 7.65 0 0 0-3.508-2.591 7.65 7.65 0 0 0-5.892.258 7.632 7.632 0 0 0-3.983 4.35c-1.45 3.992.616 8.425 4.608 9.883a7.656 7.656 0 0 0 2.625.467c3.15 0 6.117-1.942 7.25-5.075a.624.624 0 1 0-1.175-.425c-1.217 3.35-4.933 5.075-8.275 3.858-3.35-1.216-5.075-4.933-3.858-8.275a6.386 6.386 0 0 1 3.341-3.641 6.435 6.435 0 0 1 4.942-.217 6.434 6.434 0 0 1 3.25 2.625h-1.6a.63.63 0 0 0-.625.625l-.017-.017Z",
    fill: "current"
  })));
};
export default SvgRefresh;